/* angular:styles/component:css;3f90e6dd89adb340c0dceae4c3c8105a28902c3093552390d0a5cb8f4b95404b;/src/src/app/edge/live/live.component.ts */
@media (max-width: 576px) {
  .live-small-padding {
    padding-left: 1em;
    padding-right: 1em;
  }
}
/*# sourceMappingURL=live.component.css.map */
